module.exports = (__webpack_require__("dll-reference pcxbase"))("./pcx_addon/core/api/ui/modal.js");